module.exports = __webpack_public_path__ + "img/icash.2972a8a2.svg";